import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import "./contacto.scss";
import 'bootstrap/dist/css/bootstrap.min.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

export default function Contacto() {

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_b1zjx9n",
      "template_81zupka",
      form.current,
      "sdFIe0HpQP8G8SULX"
    )
      .then(
        (result) => {
          console.log(result.text);

          setName("");
          setEmail("");
          setPhone("");
          setMessage("");
        },
        (error) => {
          console.log("ERROR COMPLETO:", error);
        }
      );
  };

  return (
    <div className="contacto" id="contacto">

      <div className="contactForm">

        <h1 className="titulo">CONTACTO</h1>

        <form ref={form} onSubmit={sendEmail}>

          <div className="seccionForm">

            <div className="formulario">

              <div className="col">
                <label>Nombre y Apellido</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nombre y Apellido"
                  name="user_name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>

              <div className="col">
                <label>Email</label>
                <input
                  type="email"
                  className="form-control"
                  placeholder="Email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              <div className="col">
                <label>Teléfono</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Teléfono"
                  name="user_phone"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  required
                />
              </div>

            </div>

            <div className="datosContacto">

              <div className="datos">

                <div className="seccion">
                  <FontAwesomeIcon icon={faLocationDot} className="icono" />
                  <div className="contenido">
                    <h5>Ubicación</h5>
                    <p>Provincia de Buenos Aires y CABA</p>
                  </div>
                </div>

                <div className="seccion">
                  <FontAwesomeIcon icon={faEnvelope} className="icono" />
                  <div className="contenido">
                    <h5>Email</h5>
                    <p>jyg.agrimensura@gmail.com</p>
                  </div>
                </div>

                <div className="seccion">
                  <FontAwesomeIcon icon={faPhone} className="icono" />
                  <div className="contenido">
                    <h5>Teléfonos</h5>
                    <p>+54 11 3599-3339</p>
                    <p>+54 3487 406528</p>
                  </div>
                </div>

              </div>

              <div className="codigoQR">
                <img src="/assets/img/qr.png" className="qr" alt="QR" />
                <p>Nuestros Links</p>
              </div>

            </div>

          </div>

          <div className="msg mb-3">
            <label htmlFor="exampleFormControlTextarea1" className="form-label">Consulta</label>
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
              placeholder="Escribinos tu consulta"
              name="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </div>

          <input className="btn btn-primary btn-lg" type="submit" value="Contactanos" />

        </form>

      </div>

    </div>
  );
}